import { Component, OnInit, Output, EventEmitter, Input, ViewChild, TemplateRef } from '@angular/core';
import { SmartHelpInfo } from '../common/ExpressEntity';
import { ExpressionEditorLocalePipe } from '../utils/expression-editor-locale.pipe';

@Component({
  selector: 'app-expression-smart-help-grid',
  templateUrl: './expression-smart-help-grid.component.html',
  styleUrls: ['./expression-smart-help-grid.component.css']
})
export class ExpressionSmartHelpGridComponent implements OnInit {

  //定义i18n标识
  private localeId: string;
  private localePipe: ExpressionEditorLocalePipe;

  @ViewChild("help") help: TemplateRef<any>;

  constructor() {
    //初始化i18n标识
    this.localeId = localStorage.getItem('languageCode') || 'zh-CHS';
    this.localePipe = new ExpressionEditorLocalePipe(this.localeId);
  }
  @Input() smartHelp: SmartHelpInfo[] = [];
  @Output() selectHelpRow = new EventEmitter();
  @Output() insertValue = new EventEmitter();
  items: SmartHelpInfo[] = [];
  columns = [];
  ngOnInit() {
    this.columns = [
      { field: 'code', width: 100, title: this.localePipe.transform("HelpCode"), filter: true },
      { field: 'name', width: 100, title: this.localePipe.transform("HelpName"), filter: true },
      { field: 'description', width: 60, title: this.localePipe.transform("HelpDesc"), template: this.help },
    ];
    this.items = this.smartHelp;
  }

  openHelp($event) {
    let entities = this.smartHelp.find(temp => temp.code == $event.code);
    entities.instance.show().then(res => {
      this.insertValue.emit(res);
    })
  }

  selectRowChange($event) {
    this.selectHelpRow.emit($event.data);
  }

}
